import React, { useEffect, useRef, useState } from 'react'
import Grid from '@mui/material/Grid2';
import "./allheader.css";
import { faArrowRightFromBracket, faBars, faChevronLeft, faChevronRight, faCloudArrowUp, faFileCircleCheck, faFileCirclePlus, faNoteSticky, faUserLock, faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Accordion, Dropdown, Modal } from 'react-bootstrap';
import { apiService } from '../../services/apiService';
import { faBell, faUser, faEye, faEyeSlash, faCircleCheck } from '@fortawesome/free-regular-svg-icons';
import { toast } from 'react-toastify'; 
import Joyride from "react-joyride";
import { eventBus } from '../eventBus.js';

const profileImage = require('../../assets/defaultprofile.svg').default;
function Allheader() {
    const personates = localStorage.getItem('impersonate');
    const [countData, setCountdata] = useState({});
    const navigate = useNavigate();
    useEffect(() => {
        if(personates === "false"){
            window.location.reload();
            localStorage.removeItem('impersonate');
        }
    },[personates])
    const [generalData, setgeneraldata] = useState([]);
    useEffect(() => { 
        const fetchsetsData = async () => {
            const response = await apiService.getRequest('/general-settings');
            if (response && response.success) {
                setgeneraldata(response.data);
            }else{
                if(response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
        };
        fetchsetsData();
    }, []);
    useEffect(() => { 
        const fetchCountData = async () => {
            const response = await apiService.getRequest('/knowledge-article/status/count');
            if (response && response.success) {
                setCountdata(response.data);
            }else{
                if(response && response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
        };
        fetchCountData();
    }, [navigate]);
  const steps = [
    {
      target: ".guid_show1",
      content: "The Profile Management System is comprehensive way to manage their personal, immigration, and emergency details. ensures that all essential information is organized, up-to-date, and easily accessible.",
      placement: "right",  
    },
    {
      target: ".guid_show2",
      content: "You can click here to see dashboard!",
      placement: "bottom",
    },
    {
      target: ".guid_show3",
      content: "The Catalog is Correct My Profile, Marketing Hold Request, and Edit Registration etc.. these features empower users to manage their preferences and information seamlessly while improving operational efficiency..",
      placement: "left",
    },
  ];
    
    const isAuthenticated = !!localStorage.getItem('token');
    useEffect(() => {
        if (!isAuthenticated) {
          navigate('/login');
        }
    }, [navigate, isAuthenticated]);
    const location = useLocation();
    const currentPath = location.pathname;
    const [isActive, setIsActive] = useState(false);
    const [userprofile, setUserProfile] = useState(null);
    const [loading, setLoading] = useState(true);
    const [notifications, setNotifications] = useState([]);
    const [show, setShow] = useState(false);
    const handleClose = () => {
        setShow(false);
        setFormData({
            current_password: '',
            password: '',
            password_confirmation: '',
        });
        setErrors("");
        setErrorsMessage("");
    };
    const [show2, setShow2] = useState(false);
    const handleClose2 = () => setShow2(false);
    const userId = localStorage.getItem('userid');
    const [btnloading, setBtnLoading] = useState(false);
    // State for roles and form data
    const [formData, setFormData] = useState({
        current_password: '',
        password: '',
        password_confirmation: '',
    });
    const [errors, setErrors] = useState({});
    const [passwordVisible, setPasswordVisible] = useState(false);
    const [passwordVisible1, setPasswordVisible1] = useState(false);
    const [passwordVisible2, setPasswordVisible2] = useState(false);
    const [errorsmessage, setErrorsMessage] = useState('');

    useEffect(() => {
        if (!location.pathname.startsWith("/job-board")) {
        const keysToClear = ["jobBoardListState", "myJobsPageState", "jobBoardAdminState"];
        keysToClear.forEach((key) => {
            sessionStorage.removeItem(key);
        });
        }
        if (!location.pathname.startsWith("/user/jobseeker-details")) {
            sessionStorage.removeItem('seekerEdit');
        }
    }, [location.pathname]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };
    const validate = () => {
        const newErrors = {};
        if (formData.password !== formData.password_confirmation) newErrors.password_confirmation = 'Passwords do not match';
        if (formData.current_password.length <= 0) newErrors.current_password = 'Old Passwords is required';
        if (formData.password.length <= 0) newErrors.password = 'New Passwords is required';
        if (formData.password_confirmation.length <= 0) newErrors.password_confirmation = 'Confirm Password is required';
        // if (formData.password_confirmation.length <= 0) newErrors.password_confirmation = 'Passwords do not match';
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validate()) return;
        setBtnLoading(true);
        
    const passwordFormat = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*()\-_=+\\|{};:/?.<>])[\w!@#$%^&*()\-_=+\\|{};:/?.<>]{8,}$/;
    // Check if the password matches the format
    if (formData.password && !passwordFormat.test(formData.password)) {
        setErrors(prevErrors => ({
            ...prevErrors,
            password: 'Password must be at least 8 characters long, include an uppercase letter, a number, and a special character.',
        }));
        setBtnLoading(false);
        return; // Exit the function if password is invalid
    }
    try {
        const dataToSubmit = {
            ...formData,
        };
        
        const formDataToSend = new FormData();
        
        Object.entries(dataToSubmit).forEach(([key, value]) => {
            formDataToSend.append(key, value);
        });

        const response = await apiService.postRequest('/change-password', formDataToSend, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });

        if (response.success){
            toast( response.message || 'Updated successfully!');
            setFormData({
                current_password: '',
                password: '',
                password_confirmation: '',
            });
            setShow(false);
            setShow2(true);
            setErrors("");
            setErrorsMessage("");
        }else{
            setErrors(response.errors || "");
            setErrorsMessage(response.message || "");
        }
    } catch (error) {
        console.error("Error updating user data", error);
        setErrorsMessage("Failed to update user.");
    }finally {
        setBtnLoading(false);
    }
    };

    // Toggle password visibility
    const togglePasswordVisibility1 = () => {
        setPasswordVisible1(!passwordVisible1);
    };
    const togglePasswordVisibility = () => {
        setPasswordVisible(!passwordVisible);
    };

    const togglePasswordVisibility2 = () => {
        setPasswordVisible2(!passwordVisible2);
    };

    useEffect(() => { 
        const fetchData = async () => {
            const response = await apiService.postRequest(`profile`);
            if (response && response.success) {
                if (response && response.pending_signup === true) {
                    switch (response.pending_step) { 
                      case 'personal_questions':
                        navigate('/registration/personal-questions');
                        break;
                      case 'immigration':
                        navigate('/registration/immigration-questions'); 
                        break;
                      case 'emergency':
                        navigate('/registration/emergency-contact');
                        break;
                      default:
                        navigate('/registration/referral-information');
                    }
                } 
                setUserProfile(response.user);
                localStorage.setItem('user_alldata', JSON.stringify(response.user));
                localStorage.setItem('usernames', response.user.first_name);
                localStorage.setItem('userPhone', response.user.phone_number);
                localStorage.setItem('notifications', response.has_new_notifications);
                localStorage.setItem('permissions', JSON.stringify(response.enabled_permissions));
                const hasReloaded = localStorage.getItem('hasReloaded');
                if (!hasReloaded) {
                    localStorage.setItem('hasReloaded', 'true');
                    window.location.reload();
                }
            }else{
                if(response && response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    navigate('/login');
                }
            }
        };
        fetchData();
    }, [userId,navigate]);
    const handleLogout = async () => {
        try {
            await apiService.postRequest('/auth/logout');
                localStorage.clear();
                sessionStorage.clear();
            navigate('/login');
        } catch (error) {
            console.error('Logout error:', error);
        }
    };
    
    const handleToggle = () => {
        setIsActive(!isActive);
    };

    const [isCategoryVisible, setIsCategoryVisible] = useState(false);

    const handleKbToggle = () => {
        const newValue = !isCategoryVisible;
        setIsCategoryVisible(newValue);
        eventBus.emit('toggleCategory', newValue);
    };
    useEffect(() => {
        setIsCategoryVisible(false);
        eventBus.emit('toggleCategory', false);
    }, [location.pathname]);

    useEffect(() => {
        const handleHide = () => {
            setIsCategoryVisible(false);
            eventBus.emit('toggleCategory', false); // notify others
        };

        eventBus.on('hideCategory', handleHide);

        return () => {
            eventBus.off('hideCategory', handleHide);
        };
    }, []);
    const roles = localStorage.getItem('role');
    const notifyer = localStorage.getItem('notifications') === "true";
    const permissionstest = JSON.parse(localStorage.getItem('permissions'));
    const [filters, setFilters] = useState("knowledge_article");
    const [notifiCount, setNotifiCount] = useState({});

    const handleRecentnotify = async (filter) => {
        try {
            const response = await apiService.getRequest(`notifications?recent_notify=true&type=${filter}`);
                if(response && response.success === true){
                    setNotifications(response.data);
                    setNotifiCount(response);
                }else{
                    if(response && response.authenticate === false){
                        await apiService.postRequest('/auth/logout');
                        localStorage.clear();
                        sessionStorage.clear();
                        window.location.href = '/login';
                    }
                }
        } catch (error) {
            console.error('Error Notifiction Data:', error);
        }finally{
            setLoading(false);
        }
    };  

    const handleDelete = async (id) => {
        try {
            const response = await apiService.deleteRequest(`/notifications/${id}`);
            if (response && response.success === true) {
                toast("Notification Cleared")
                handleRecentnotify();
            }else{
                if(response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
        } catch (error) {
            console.error("Error deleting notification:", error);
        }
    };

    const [showDropdown, setShowDropdown] = useState(false);

    const handleViewMore = () => {
        setShowDropdown(false);
    };
    const handleimpersonates = async () =>{
        try {
            const loginResponse = await apiService.postRequest('stop-impersonating');
            if (loginResponse && loginResponse.success === true) {
                const session_warning = loginResponse.session_warning;
                const session_timeout = loginResponse.session_timeout;
                const expiryTime = Date.now() + session_timeout * 60 * 1000;
                const token = loginResponse.token;
                const user_type = loginResponse.user_type;
                const user_id = loginResponse.user_id;
                localStorage.setItem('token', token);
                localStorage.setItem("sessionExpiry", expiryTime.toString());
                localStorage.setItem("sessionWarning", session_warning.toString());
                localStorage.setItem('role', user_type);
                localStorage.setItem('userid', user_id);
                localStorage.setItem('impersonate', false);
                localStorage.removeItem('hasReloaded');
                navigate("/dashboard");
                window.location.reload();
            }else{
                toast(loginResponse.message);
                localStorage.clear();
                sessionStorage.clear();
                navigate('/login');
            }
        } catch (error) {
            console('Failed. Please try again.',error);
        }
    }
    const [visibleId, setVisibleId] = useState(null);
    const [positions, setPositions] = useState({});
    const hideTimeouts = useRef({});
    const rafRef = useRef(null);
    const elementRefs = useRef({});

    // Track position while tooltip is visible
    const trackTooltipPosition = (id) => {
    if (!elementRefs.current[id]) return;

    const update = () => {
        const rect = elementRefs.current[id]?.getBoundingClientRect();
        if (rect) {
        setPositions((prev) => ({
            ...prev,
            [id]: {
            top: rect.top,
            left: rect.right,
            },
        }));
        }
        rafRef.current = requestAnimationFrame(update);
    };

    rafRef.current = requestAnimationFrame(update);
    };

    const stopTracking = () => {
    cancelAnimationFrame(rafRef.current);
    };

    const handleMouseEnter = (e, id) => {
    elementRefs.current[id] = e.currentTarget;
    clearTimeout(hideTimeouts.current[id]);
    setVisibleId(id);
    trackTooltipPosition(id);
    };

    const handleMouseLeave = (id) => {
    hideTimeouts.current[id] = setTimeout(() => {
        setVisibleId((currentId) => {
        if (currentId === id) stopTracking();
        return currentId === id ? null : currentId;
        });
    }, 200);
    };

    const handleTooltipEnter = (id) => {
    clearTimeout(hideTimeouts.current[id]);
    };

    const handleTooltipLeave = (id) => {
    hideTimeouts.current[id] = setTimeout(() => {
        setVisibleId((currentId) => {
        if (currentId === id) stopTracking();
        return currentId === id ? null : currentId;
        });
    }, 200);
    };
  return (
    <div className='container-fluid px-0' style={{maxHeight:"100vh"}}>
        <Joyride
            steps={steps}
            // run={run}
            run={false}
            continuous
            showSkipButton
            styles={{
                options: {
                arrowColor: "#fff",
                backgroundColor: "#fff",
                primaryColor: "#C32A7C",  
                textColor: "#000",
                zIndex: 10000,
                },
            }}
        />
        <Grid size={{lg:12,xs:12}} container className="flow_headermain" justifyContent="space-between" alignItems="center">
            <Grid container className="gap-3">
                <button className='menubtn_mobile' onClick={handleKbToggle}>{!isCategoryVisible ? <FontAwesomeIcon icon={faBars} /> :<FontAwesomeIcon icon={faXmark} />}</button>
                <Link to="/" className='logo_headloged'>
                {generalData && generalData.site_logo ? <img src={generalData.site_logo} alt=''/> :
                    <img src={require("../../assets/logo.svg").default} alt=''/>
                }</Link>
            </Grid>
            <Grid container alignItems="center" className="setheaderprofile">
            {personates && 
            <button onClick={handleimpersonates} className='registersendbtn2 my-0 me-3 px-4' style={{width:"max-content"}}>Exit Impersonate</button>}
                {currentPath === "/notification" ? 
                    "" :
                    <Dropdown show={showDropdown} onToggle={(isOpen) => setShowDropdown(isOpen)} className='d-lg-block d-none'>
                    <Dropdown.Toggle className={notifyer ? 'notification_btn notiafterset' : 'notification_btn'}>
                    <FontAwesomeIcon icon={faBell} 
                    onClick={()=> handleRecentnotify("knowledge_article")}
                    />
                    </Dropdown.Toggle>
                    <Dropdown.Menu className='px-md-2 px-2 dropdown_notify_widthset'>
                        <Grid size={{xs:12}} container justifyContent="space-between">
                            <h5 style={{color:"#C42B7D"}}>Notification</h5>
                            <Link to="/notification" className='notify_viewmore' onClick={handleViewMore}>
                                View More
                            </Link>
                        </Grid> 
                        {loading ?  
                        <div className='d-flex justify-content-center w-100 mt-5 pt-5'>
                            <img style={{ width: "100px" }} src={require('../../assets/pinkloader.gif')} alt='Loading...' />
                        </div> :<>
                        <Grid size={{xs:12}} container justifyContent="flex-start" className="statusselectbtn">
                            <div className='admintab_btnredirect d-flex mt-3 ms-3 flex-wrap notify_tabfilter'>
                                <button className={filters === "knowledge_article" ? `active_tabbtn` : ""} onClick={()=>{ handleRecentnotify("knowledge_article"); setFilters("knowledge_article")}}>Knowledge {notifiCount?.kba_unread_count !== 0 && <span className='notify_number'>{notifiCount?.kba_unread_count}</span>}</button>
                                <button className={filters === "task" ? `active_tabbtn`: ""} onClick={() =>{handleRecentnotify("task"); setFilters("task")}}>Case {notifiCount?.task_case_unread_count !== 0 && <span className='notify_number'>{notifiCount?.task_case_unread_count}</span>}</button>
                            </div>
                        </Grid>
                        {Array.isArray(notifications) && notifications.length === 0 ? (
                            <div className='d-flex justify-content-center w-100 py-5'>
                                <span className='text-center w-100'>No New Notifications</span>
                            </div>
                        ) : (notifications && notifications.map(notification => (
                        <Grid size={{xs:12}} key={notification.id} container justifyContent="center" alignItems="flex-start" className="noti_contentgrid mt-3">
                            <Grid size={{xs:11}} className={notification && notification.data && notification.data.access ? "cursorpointgrid" :""} container onClick={() => {
                                if (notification && notification.data) {
                                    if (notification.data.access === true && notification.data.type === "knowledge_article") {
                                        if (notification.data.status === "draft") {  
                                            navigate(`/knowledge/edit-article/${notification.data.id}`);
                                        }else if(notification.data.status === "under_approval"){
                                            navigate(`/knowledge/under-approval/show/${notification.data.id}`);
                                        }else if(notification.data.status === "published"){
                                            navigate(`/knowledge-article/${notification.data.formatted_id}`);
                                        }else if(notification.data.status === "retired"){
                                            navigate(`/knowledge/edit-article/${notification.data.id}`);
                                        }
                                    }else if(notification.data.access === true && notification.data.type === "employee_reviews"){
                                        navigate(`/employee-reviews/view/${notification.data.employee_id}?review`)
                                    }
                                }
                            }}>
                                {Array.isArray(notification) && notification.length === 0 && <span>No data</span>}
                                <Grid size={{sm:2,xs:2}} container justifyContent="center">
                                    <img className='notify_profileimg' src={notification.profile || profileImage} alt=''/>
                                </Grid>
                                <Grid size={{sm:10,xs:10}} container flexDirection='column'>
                                    <span><b>{notification.title}</b> {notification.message}</span>
                                    <small>{notification.created_at}</small>
                                </Grid>
                            </Grid>
                            <Grid size={{xs:1}} container justifyContent="center">
                                <button
                                onClick={() => handleDelete(notification.id)}
                                ><FontAwesomeIcon icon={faXmark} /></button>
                            </Grid>
                        </Grid> 
                        )))}
                        </>}
                    </Dropdown.Menu>
                </Dropdown>
                }
                
                <img className='fake_profile guid_show1' src={(userprofile && userprofile.profile_picture) || profileImage} alt=""/>
                <Dropdown>
                    <Dropdown.Toggle className='drop_btnlogout ps-0 d-flex align-items-center' >
                    <font className="d-md-block d-none">{userprofile?.first_name || ''}</font>
                    <font className="d-md-none d-block">{userprofile?.first_name?.length > 5 ? `${userprofile.first_name.slice(0, 5)}...` : userprofile?.first_name || ''}</font>
                    </Dropdown.Toggle>
                    <Dropdown.Menu className='px-2 lg profile_dropdown_header'>
                        <button className='d-lg-block d-none'
                            onClick={() => {
                                if (roles && roles === "job_seeker") {  
                                    navigate("/profile/jobseeker");
                                }else{
                                    navigate("/profile/member");
                                }
                            }}
                        ><FontAwesomeIcon icon={faUser} /> My Profile</button>
                        <button className='d-lg-block d-none' onClick={()=>setShow(true)}><FontAwesomeIcon icon={faUserLock} /> Password Change</button>
                        <button onClick={handleLogout}><FontAwesomeIcon icon={faArrowRightFromBracket} /> Logout</button>
                    </Dropdown.Menu>
                </Dropdown>
                
            </Grid>
        </Grid>
        <div className='d-flex w-100'>
            <div className={isActive ? 'activeside sidebarfixed' : 'sidebarfixed'}>
                <div className='d-md-flex d-none justify-content-end'>
                <button className='button_sidetoggler' onClick={handleToggle}>{isActive ? <FontAwesomeIcon icon={faChevronLeft} /> : <FontAwesomeIcon icon={faChevronRight} />}</button>
                </div>
                {isActive ?
                <div className='inner_scrollsidebar'>
                    <div className={currentPath === "/dashboard" ? "sidelinks  active_side" : "sidelinks"} >
                        <Link to="/dashboard" className='inner_layer guid_show2'>
                            <img src={require('../../assets/sidebaricons/icon1.svg').default} alt=''/>
                            <span>Dashboard</span>
                        </Link>
                    </div>
                    {(roles === 'admin' || roles === "sub_admin") && <>
                        { permissionstest && (permissionstest.manage_jobseeker_reader === true || permissionstest.manage_subadmin_reader === true || permissionstest.manage_group_reader === true ) ?
                            <div className={currentPath.startsWith("/user") ? "sidelinks active_side" : "sidelinks"} >
                                <Link to={
                                    (permissionstest.manage_jobseeker_reader || permissionstest.manage_jobseeker_writer) &&
                                    (permissionstest.manage_subadmin_reader || permissionstest.manage_subadmin_writer) &&
                                    permissionstest.manage_group_reader
                                        ? "/user/jobseekers"
                                        : (permissionstest.manage_jobseeker_reader || permissionstest.manage_jobseeker_writer) &&
                                        !(permissionstest.manage_subadmin_reader || permissionstest.manage_subadmin_writer) &&
                                        permissionstest.manage_group_reader
                                        ? "/user/jobseekers"
                                        : (permissionstest.manage_jobseeker_reader || permissionstest.manage_jobseeker_writer) &&
                                        (permissionstest.manage_subadmin_reader || permissionstest.manage_subadmin_writer) &&
                                        !permissionstest.manage_group_reader
                                        ? "/user/jobseekers"
                                        : (permissionstest.manage_jobseeker_reader || permissionstest.manage_jobseeker_writer) &&
                                        !(permissionstest.manage_subadmin_reader || permissionstest.manage_subadmin_writer) &&
                                        !permissionstest.manage_group_reader
                                        ? "/user/jobseekers"
                                        : !(permissionstest.manage_jobseeker_reader || permissionstest.manage_jobseeker_writer) &&
                                        (permissionstest.manage_subadmin_reader || permissionstest.manage_subadmin_writer) &&
                                        permissionstest.manage_group_reader
                                        ? "/user/member"
                                        : !(permissionstest.manage_jobseeker_reader || permissionstest.manage_jobseeker_writer) &&
                                        (permissionstest.manage_subadmin_reader || permissionstest.manage_subadmin_writer) &&
                                        !permissionstest.manage_group_reader
                                        ? "/user/member"
                                        : !(permissionstest.manage_jobseeker_reader || permissionstest.manage_jobseeker_writer) &&
                                        !(permissionstest.manage_subadmin_reader || permissionstest.manage_subadmin_writer) &&
                                        permissionstest.manage_group_reader
                                        ? "/user/group"
                                        : "/login" // Default fallback
                                } className='inner_layer'>
                                    <img src={require('../../assets/sidebaricons/icon5.svg').default} alt=''/>
                                    <span>User</span>
                                </Link>
                            </div>
                        :""}
                        {permissionstest && permissionstest.manage_knowledge_article === true &&<>
                        { permissionstest.manage_kba_admin === true || permissionstest.manage_kba_creator === true ?
                            <div className={currentPath.startsWith("/knowledge") ? "sidelinks active_side" : "sidelinks"}>
                                <div className='inner_layer_accord'>
                                    <Accordion>
                                        <Accordion.Item eventKey="0">
                                            <Accordion.Header className='accor_headbtn'><img src={require('../../assets/sidebaricons/icon3.svg').default} alt=''/>Manage Knowledge</Accordion.Header>
                                            <Accordion.Body>
                                            <div className='d-flex flex-column beforesets_sidebar'>
                                                <small className={currentPath === "/knowledge" ? "activesmallersb" : ""}><Link className="link_headsets" to="/knowledge" >List of Articles</Link></small>
                                                <small className='sidebaraccords p-0'>
                                                <Accordion>
                                                    <Accordion.Item eventKey="0">
                                                        <Accordion.Header className=''>Manage the Knowledge</Accordion.Header>
                                                        <Accordion.Body>
                                                            <div className='d-flex flex-column'>
                                                                <small className={ currentPath === "/knowledge/draft" || currentPath === "/knowledge/add-draft" ? "active_accordsmall" : ""}><Link className="link_headsets" to="/knowledge/draft" ><div className='d-flex flex-wrap justify-content-between'><div><FontAwesomeIcon className='icons' icon={faFileCirclePlus} />Draft</div> {countData?.draft_count !== 0 &&<div className='smallnumnotify'>{countData?.draft_count}</div>}</div></Link></small>
                                                                <small className={ currentPath === "/knowledge/under-approval" ? "active_accordsmall" : ""} ><Link className="link_headsets" to="/knowledge/under-approval" ><div className='d-flex flex-wrap justify-content-between'><div><FontAwesomeIcon className='icons' icon={faNoteSticky} />Under Approval</div> {countData?.under_approval_count !== 0 &&<div className='smallnumnotify'>{countData?.under_approval_count}</div>}</div></Link></small>
                                                                <small className={ currentPath.startsWith("/knowledge/published") ? "active_accordsmall" : ""} ><Link className="link_headsets" to="/knowledge/published" ><div className='d-flex flex-wrap justify-content-between'><div><FontAwesomeIcon className='icons' icon={faFileCircleCheck} />Published</div> {countData?.published_count !== 0 &&<div className='smallnumnotify'>{countData?.published_count}</div>}</div></Link></small>
                                                                <small className={ currentPath.startsWith("/knowledge/retired") ? "active_accordsmall" : ""} ><Link className="link_headsets" to="/knowledge/retired" ><div className='d-flex flex-wrap justify-content-between'><div><FontAwesomeIcon className='icons' icon={faCloudArrowUp} />Retired</div> {countData?.retired_count !== 0 &&<div className='smallnumnotify'>{countData?.retired_count}</div>}</div></Link></small>
                                                            </div>
                                                        </Accordion.Body>
                                                    </Accordion.Item>
                                                </Accordion>
                                                </small>
                                                {roles === 'admin' && <>
                                                    <small className={currentPath === "/knowledge/root" ? "activesmallersb" : ""} ><Link className="link_headsets" to="/knowledge/root" >Knowledge Base</Link></small>
                                                    <small className={currentPath === "/knowledge/category" ? "activesmallersb" : ""} ><Link className="link_headsets" to="/knowledge/category" >Category</Link></small>
                                                    <small className={currentPath === "/knowledge/sub-category" ? "activesmallersb" : ""} ><Link className="link_headsets" to="/knowledge/sub-category" >Sub Category</Link></small>
                                                </>}
                                                
                                            </div>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    </Accordion>
                                </div>
                            </div>
                            : 
                            <div className={currentPath.startsWith("/knowledge") ? "sidelinks active_side" : "sidelinks"} >
                                <Link to="/knowledge" className='inner_layer'>
                                    <img src={require('../../assets/sidebaricons/icon3.svg').default} alt=''/>
                                    <span>Knowledge Article</span>
                                </Link>
                            </div>
                        }</>}
                        {permissionstest && permissionstest.manage_community_members === true && (permissionstest.manage_community_creator === true || permissionstest.manage_community_editor === true || permissionstest.manage_community_remover === true) ?
                            <div className={currentPath.startsWith("/community-member") ? "sidelinks active_side" : "sidelinks"} >
                                <Link to="/community-member" className='inner_layer'>
                                    <img src={require('../../assets/sidebaricons/icon13.svg').default} alt=''/>
                                    <span>Community Member</span>
                                </Link>
                            </div>
                        :""}
                        {permissionstest && permissionstest.manage_case_admin === true ?
                            <div className={currentPath.startsWith("/case") ? "sidelinks active_side" : "sidelinks"}>
                                <div className='inner_layer_accord'>
                                    <Accordion>
                                        <Accordion.Item eventKey="0">
                                            <Accordion.Header className='accor_headbtn'><img src={require('../../assets/sidebaricons/case_management.svg').default} alt=''/>Case Management</Accordion.Header>
                                            <Accordion.Body>
                                            <div className='d-flex flex-column beforesets_sidebar'>
                                                <small className={currentPath === "/case/solution" ? "activesmallersb" : ""}><Link className="link_headsets" to="/case/solution" >Solutions</Link></small>
                                                <small className={currentPath === "/case/case-type" ? "activesmallersb" : ""} ><Link className="link_headsets" to="/case/case-type" >Case Types</Link></small>
                                                <small className={currentPath === "/case/case-sub-type" ? "activesmallersb" : ""} ><Link className="link_headsets" to="/case/case-sub-type" >Case Sub Types</Link></small>
                                            </div>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    </Accordion>
                                </div>
                            </div>
                        :""}
                        {permissionstest && permissionstest.manage_my_tasks === true ?
                            <div className={currentPath.startsWith("/task") ? "sidelinks active_side" : "sidelinks"}>
                                <Link to={"/task/my-task"} className='inner_layer'>
                                    <img src={require('../../assets/sidebaricons/icon6.svg').default} alt=''/>
                                    <span>Task</span>
                                </Link>
                            </div>
                        :""}
                    </>}
                    {(roles && roles === 'job_seeker' && permissionstest && permissionstest.manage_knowledge_article === true) &&
                        <div className={currentPath.startsWith("/knowledge") ? "sidelinks active_side" : "sidelinks"} >
                            <Link to="/knowledge" className='inner_layer'>
                                <img src={require('../../assets/sidebaricons/icon3.svg').default} alt=''/>
                                <span>Knowledge Article</span>
                            </Link>
                        </div>
                    }
                    {permissionstest && permissionstest.manage_catalog === true && <>
                        <div className={currentPath.startsWith("/catalogs") ? "sidelinks active_side" : "sidelinks"}>
                            <Link to="/catalogs/global-services" className='inner_layer guid_show3'>
                                <img src={require('../../assets/sidebaricons/icon2.svg').default} alt=''/>
                                <span>Catalog</span>
                            </Link>
                        </div>
                    </>}
                    {(roles && roles === 'job_seeker' && permissionstest && permissionstest.manage_my_tasks === true) &&
                        <div className={currentPath.startsWith("/task") ? "sidelinks active_side" : "sidelinks"}>
                            <Link to="/task/my-task" className='inner_layer'>
                                <img src={require('../../assets/sidebaricons/icon6.svg').default} alt=''/>
                                <span>Task</span>
                            </Link>
                        </div>
                    }
                    {roles && roles !== "job_seeker" && permissionstest && permissionstest.manage_job_posts === true && permissionstest.manage_job_post_viewer === true && <>
                    <div className={currentPath.startsWith("/job-board") ? "sidelinks active_side" : "sidelinks"} >
                        <Link to="/job-board" className='inner_layer' onClick={() =>{navigate("/job-board")}}>
                            <img src={require('../../assets/sidebaricons/icon12.svg').default} alt=''/>
                            <span>Job Board</span>
                        </Link>
                    </div>
                    </>}
                    {roles && roles !== "job_seeker" && permissionstest?.recruiter_admin === true && <>
                    <div className={currentPath.startsWith("/recruiter") ? "sidelinks active_side" : "sidelinks"}>
                        <div className='inner_layer_accord'>
                            <Accordion>
                                <Accordion.Item eventKey="0">
                                    <Accordion.Header className='accor_headbtn'><img src={require('../../assets/sidebaricons/icon18.svg').default} alt=''/>C2C</Accordion.Header>
                                    <Accordion.Body>
                                    <div className='d-flex flex-column beforesets_sidebar'>
                                        <small className={currentPath === "/recruiter/it-recruiter" ? "activesmallersb" : ""}><Link className="link_headsets" to="/recruiter/it-recruiter" >IT Recruiter</Link></small>
                                        <small className={currentPath === "/recruiter/vendor-company" ? "activesmallersb" : ""} ><Link className="link_headsets" to="/recruiter/vendor-company" >Vendor Company</Link></small>
                                    </div>
                                    </Accordion.Body>
                                </Accordion.Item>
                            </Accordion>
                        </div>
                    </div></>}
                    {(roles && roles === 'job_seeker' && permissionstest && permissionstest.manage_job_posts === true && permissionstest.manage_job_post_viewer === true) &&
                    <div className={currentPath.startsWith("/job-board") ? "sidelinks active_side" : "sidelinks"} >
                        <Link to="/job-board/job-list" className='inner_layer'>
                            <img src={require('../../assets/sidebaricons/icon12.svg').default} alt=''/>
                            <span>Job Board</span>
                        </Link>
                    </div>
                    }

                    {(roles === 'admin') &&
                        <div className={currentPath.startsWith("/settings") ? "sidelinks active_side" : "sidelinks"}>
                            <Link to="/settings/general" className='inner_layer'>
                                <img src={require('../../assets/sidebaricons/icon11.svg').default} alt=''/>
                                <span>Company Settings</span>
                            </Link>
                        </div>
                    }
                    {permissionstest && permissionstest.manage_employee_reviews === true  &&
                        <div className={currentPath.startsWith("/employee-reviews") ? "sidelinks active_side" : "sidelinks"}>
                            <Link to="/employee-reviews" className='inner_layer'>
                                <img src={require('../../assets/sidebaricons/icon14.svg').default} alt=''/>
                                <span>Employee Reviews</span>
                            </Link>
                        </div>
                    }
                    {permissionstest && permissionstest.manage_org_chart === true &&
                        <div className={currentPath.startsWith("/org-chart") ? "sidelinks active_side" : "sidelinks"}>
                            <Link to="/org-chart" className='inner_layer'>
                                <img src={require('../../assets/sidebaricons/icon15.svg').default} alt=''/>
                                <span>Org Chart</span>
                            </Link>
                        </div>
                    }
                </div>
                :
                <>
                <div className='inner_scrollsidebar'>
                    <div className={currentPath === "/dashboard" ? "sidelinks active_side trigger" : "sidelinks trigger"} onMouseEnter={(e) => handleMouseEnter(e, 1)} onMouseLeave={() => handleMouseLeave(1)}>
                        <Link to="/dashboard" className='inner_layer guid_show2'>
                            <img src={require('../../assets/sidebaricons/icon1.svg').default} alt=''/>
                            <span className="target target_sidevisible"
                            onMouseEnter={() => handleTooltipEnter(1)}
                            onMouseLeave={() => handleTooltipLeave(1)}
                            style={{
                                display: visibleId === 1 ? 'block' : 'block',
                                position: 'fixed',
                                top: positions[1]?.top ?? 0,
                                left: visibleId === 1 && positions[1]?.left !== undefined ? positions[1].left : -255,
                                // left: positions[1]?.left ?? 0,
                            }}>Dashboard</span>
                        </Link>
                    </div>
                    {(roles === 'admin' || roles === "sub_admin") && <>
                        { permissionstest && (permissionstest.manage_jobseeker_reader === true || permissionstest.manage_subadmin_reader === true || permissionstest.manage_group_reader === true ) ?
                            <div className={currentPath.startsWith("/user") ? "sidelinks active_side trigger" : "sidelinks trigger"} onMouseEnter={(e) => handleMouseEnter(e, 2)} onMouseLeave={() => handleMouseLeave(2)}>
                                <Link to={
                                    (permissionstest.manage_jobseeker_reader || permissionstest.manage_jobseeker_writer) &&
                                    (permissionstest.manage_subadmin_reader || permissionstest.manage_subadmin_writer) &&
                                    permissionstest.manage_group_reader
                                        ? "/user/jobseekers"
                                        : (permissionstest.manage_jobseeker_reader || permissionstest.manage_jobseeker_writer) &&
                                        !(permissionstest.manage_subadmin_reader || permissionstest.manage_subadmin_writer) &&
                                        permissionstest.manage_group_reader
                                        ? "/user/jobseekers"
                                        : (permissionstest.manage_jobseeker_reader || permissionstest.manage_jobseeker_writer) &&
                                        (permissionstest.manage_subadmin_reader || permissionstest.manage_subadmin_writer) &&
                                        !permissionstest.manage_group_reader
                                        ? "/user/jobseekers"
                                        : (permissionstest.manage_jobseeker_reader || permissionstest.manage_jobseeker_writer) &&
                                        !(permissionstest.manage_subadmin_reader || permissionstest.manage_subadmin_writer) &&
                                        !permissionstest.manage_group_reader
                                        ? "/user/jobseekers"
                                        : !(permissionstest.manage_jobseeker_reader || permissionstest.manage_jobseeker_writer) &&
                                        (permissionstest.manage_subadmin_reader || permissionstest.manage_subadmin_writer) &&
                                        permissionstest.manage_group_reader
                                        ? "/user/member"
                                        : !(permissionstest.manage_jobseeker_reader || permissionstest.manage_jobseeker_writer) &&
                                        (permissionstest.manage_subadmin_reader || permissionstest.manage_subadmin_writer) &&
                                        !permissionstest.manage_group_reader
                                        ? "/user/member"
                                        : !(permissionstest.manage_jobseeker_reader || permissionstest.manage_jobseeker_writer) &&
                                        !(permissionstest.manage_subadmin_reader || permissionstest.manage_subadmin_writer) &&
                                        permissionstest.manage_group_reader
                                        ? "/user/group"
                                        : "/login" // Default fallback
                                } className='inner_layer'>
                                    <img src={require('../../assets/sidebaricons/icon5.svg').default} alt=''/>
                                    <span className="target target_sidevisible"
                                        onMouseEnter={() => handleTooltipEnter(2)}
                                        onMouseLeave={() => handleTooltipLeave(2)}
                                        
                                        style={{
                                            display: visibleId === 2 ? 'block' : 'block',
                                            position: 'fixed',
                                            top: positions[2]?.top ?? 0,
                                            left: visibleId === 2 && positions[2]?.left !== undefined ? positions[2].left : -255,
                                            // left: positions[1]?.left ?? 0,
                                        }}>User</span>
                                </Link>
                            </div>
                        :""}
                        {permissionstest && permissionstest.manage_knowledge_article === true &&<>
                        { permissionstest.manage_kba_admin === true || permissionstest.manage_kba_creator === true ?
                            <div className={currentPath.startsWith("/knowledge") ? "sidelinks active_side trigger" : "sidelinks trigger"} onMouseEnter={(e) => handleMouseEnter(e, 5)} onMouseLeave={() => handleMouseLeave(5)}>
                                <div className='inner_layer'>
                                    <img src={require('../../assets/sidebaricons/icon3.svg').default} alt=''/>
                                    <span className='sidenewdrshows target' 
                                        onMouseEnter={() => handleTooltipEnter(5)}
                                        onMouseLeave={() => handleTooltipLeave(5)}
                                        style={{
                                            display: visibleId === 5 ? 'block' : 'block',
                                            position: 'fixed',
                                            top: positions[5]?.top ?? 0,
                                            left: visibleId === 5 && positions[5]?.left !== undefined ? positions[5].left : -255,
                                            // left: positions[1]?.left ?? 0,
                                        }}>Manage Knowledge
                                        <div className='list_showers'>
                                            <div className='d-flex flex-column'>
                                                <small className={currentPath === "/knowledge" ? "activesmallersb" : ""}><Link className="link_headsets" to="/knowledge" >List of Articles</Link></small>
                                                <small className='sidebaraccords'>
                                                <Accordion>
                                                    <Accordion.Item eventKey="0">
                                                        <Accordion.Header>Manage the Knowledge</Accordion.Header>
                                                        <Accordion.Body>
                                                            <div className='d-flex flex-column'>
                                                                <small className={ currentPath === "/knowledge/draft" || currentPath === "/knowledge/add-draft" ? "active_accordsmall" : ""}><Link className="link_headsets" to="/knowledge/draft" ><div className='d-flex flex-wrap justify-content-between'><div><FontAwesomeIcon className='icons' icon={faFileCirclePlus} />Draft</div> {countData?.draft_count !== 0 &&<div className='smallnumnotify'>{countData?.draft_count}</div>}</div></Link></small>
                                                                <small className={ currentPath === "/knowledge/under-approval" ? "active_accordsmall" : ""} ><Link className="link_headsets" to="/knowledge/under-approval" ><div className='d-flex flex-wrap justify-content-between'><div><FontAwesomeIcon className='icons' icon={faNoteSticky} />Under Approval</div> {countData?.under_approval_count !== 0 &&<div className='smallnumnotify'>{countData?.under_approval_count}</div>}</div></Link></small>
                                                                <small className={ currentPath.startsWith("/knowledge/published") ? "active_accordsmall" : ""} ><Link className="link_headsets" to="/knowledge/published" ><div className='d-flex flex-wrap justify-content-between'><div><FontAwesomeIcon className='icons' icon={faFileCircleCheck} />Published</div> {countData?.published_count !== 0 &&<div className='smallnumnotify'>{countData?.published_count}</div>}</div></Link></small>
                                                                <small className={ currentPath.startsWith("/knowledge/retired") ? "active_accordsmall" : ""} ><Link className="link_headsets" to="/knowledge/retired" ><div className='d-flex flex-wrap justify-content-between'><div><FontAwesomeIcon className='icons' icon={faCloudArrowUp} />Retired</div> {countData?.retired_count !== 0 &&<div className='smallnumnotify'>{countData?.retired_count}</div>}</div></Link></small>
                                                            </div>
                                                        </Accordion.Body>
                                                    </Accordion.Item>
                                                </Accordion>
                                                </small>
                                                {roles === 'admin' && <>
                                                    <small className={currentPath === "/knowledge/root" ? "activesmallersb" : ""} ><Link className="link_headsets" to="/knowledge/root" >Knowledge Base</Link></small>
                                                    <small className={currentPath === "/knowledge/category" ? "activesmallersb" : ""} ><Link className="link_headsets" to="/knowledge/category" >Category</Link></small>
                                                    <small className={currentPath === "/knowledge/sub-category" ? "activesmallersb" : ""} ><Link className="link_headsets" to="/knowledge/sub-category" >Sub Category</Link></small>
                                                </>}
                                            </div>
                                        </div>
                                    </span>
                                </div>
                            </div>
                            : 
                            <div className={currentPath.startsWith("/knowledge") ? "sidelinks active_side trigger" : "sidelinks trigger"} onMouseEnter={(e) => handleMouseEnter(e, 6)} onMouseLeave={() => handleMouseLeave(6)}>
                                <Link to="/knowledge" className='inner_layer'>
                                    <img src={require('../../assets/sidebaricons/icon3.svg').default} alt=''/>
                                    <span className="target target_sidevisible"
                                        onMouseEnter={() => handleTooltipEnter(6)}
                                        onMouseLeave={() => handleTooltipLeave(6)}
                                        style={{
                                            display: visibleId === 6 ? 'block' : 'block',
                                            position: 'fixed',
                                            top: positions[6]?.top ?? 0,
                                            left: visibleId === 6 && positions[6]?.left !== undefined ? positions[6].left : -255,
                                            // left: positions[1]?.left ?? 0,
                                        }}>Knowledge Article</span>
                                </Link>
                            </div>
                        }</>}
                        {permissionstest && permissionstest.manage_community_members === true && (permissionstest.manage_community_creator === true || permissionstest.manage_community_editor === true || permissionstest.manage_community_remover === true) ?
                            <div className={currentPath.startsWith("/community-member") ? "sidelinks active_side trigger" : "sidelinks trigger"} onMouseEnter={(e) => handleMouseEnter(e, 7)} onMouseLeave={() => handleMouseLeave(7)}>
                                <Link to="/community-member" className='inner_layer'>
                                    <img src={require('../../assets/sidebaricons/icon13.svg').default} alt=''/>
                                    <span className="target target_sidevisible"
                                        onMouseEnter={() => handleTooltipEnter(7)}
                                        onMouseLeave={() => handleTooltipLeave(7)}
                                        style={{
                                            display: visibleId === 7 ? 'block' : 'block',
                                            position: 'fixed',
                                            top: positions[7]?.top ?? 0,
                                            left: visibleId === 7 && positions[7]?.left !== undefined ? positions[7].left : -255,
                                            // left: positions[1]?.left ?? 0,
                                        }}>Community Member</span>
                                </Link>
                            </div>
                        :""}
                        {permissionstest && permissionstest.manage_case_admin === true &&
                        <div className={currentPath.startsWith("/case") ? "sidelinks active_side trigger" : "sidelinks trigger"} onMouseEnter={(e) => handleMouseEnter(e, 17)} onMouseLeave={() => handleMouseLeave(17)}>
                            <div className='inner_layer'>
                                <img src={require('../../assets/sidebaricons/case_management.svg').default} alt=''/>
                                <span className='sidenewdrshows target' 
                                    onMouseEnter={() => handleTooltipEnter(17)}
                                    onMouseLeave={() => handleTooltipLeave(17)}
                                    style={{
                                        display: visibleId === 17 ? 'block' : 'block',
                                        position: 'fixed',
                                        top: positions[17]?.top ?? 0,
                                        left: visibleId === 17 && positions[17]?.left !== undefined ? positions[17].left : -255,
                                        // left: positions[1]?.left ?? 0,
                                    }}>Case Management
                                    <div className='list_showers'>
                                        <div className='d-flex flex-column'>
                                            <small className={currentPath === "/case/solution" ? "activesmallersb" : ""}><Link className="link_headsets" to="/case/solution" >Solutions</Link></small>
                                            <small className={currentPath === "/case/case-type" ? "activesmallersb" : ""} ><Link className="link_headsets" to="/case/case-type" >Case Types</Link></small>
                                            <small className={currentPath === "/case/case-sub-type" ? "activesmallersb" : ""} ><Link className="link_headsets" to="/case/case-sub-type" >Case Sub Types</Link></small>
                                        </div>
                                    </div>
                                </span>
                            </div>
                        </div>
                        }
                        {permissionstest && permissionstest.manage_my_tasks === true ?
                            <div className={currentPath.startsWith("/task") ? "sidelinks active_side trigger" : "sidelinks trigger"} onMouseEnter={(e) => handleMouseEnter(e, 8)} onMouseLeave={() => handleMouseLeave(8)}>
                                <Link to={roles && roles !== 'job_seeker'
                                        ? "/task/my-task"
                                        : "/task/my-task"} className='inner_layer'>
                                    <img src={require('../../assets/sidebaricons/icon6.svg').default} alt=''/>
                                    <span className="target target_sidevisible"
                                        onMouseEnter={() => handleTooltipEnter(8)}
                                        onMouseLeave={() => handleTooltipLeave(8)}
                                        style={{
                                            display: visibleId === 8 ? 'block' : 'block',
                                            position: 'fixed',
                                            top: positions[8]?.top ?? 0,
                                            left: visibleId === 8 && positions[8]?.left !== undefined ? positions[8].left : -255,
                                            // left: positions[1]?.left ?? 0,
                                        }}>Task</span>
                                </Link>
                            </div>
                        :""}
                    </>}
                    {(roles && roles === 'job_seeker' && permissionstest && permissionstest.manage_knowledge_article === true) &&
                        <div className={currentPath.startsWith("/knowledge") ? "sidelinks active_side trigger" : "sidelinks trigger"} onMouseEnter={(e) => handleMouseEnter(e, 3)} onMouseLeave={() => handleMouseLeave(3)}>
                            <Link to="/knowledge" className='inner_layer'>
                                <img src={require('../../assets/sidebaricons/icon3.svg').default} alt=''/>
                                <span className="target target_sidevisible"
                                    onMouseEnter={() => handleTooltipEnter(3)}
                                    onMouseLeave={() => handleTooltipLeave(3)}
                                    style={{
                                        display: visibleId === 3 ? 'block' : 'block',
                                        position: 'fixed',
                                        top: positions[3]?.top ?? 0,
                                        left: visibleId === 3 && positions[3]?.left !== undefined ? positions[3].left : -255,
                                        // left: positions[1]?.left ?? 0,
                                    }}>Knowledge Article</span>
                            </Link>
                        </div>
                    }
                    {permissionstest && permissionstest.manage_catalog === true && <>
                        <div className={currentPath.startsWith("/catalogs") ? "sidelinks active_side trigger" : "sidelinks trigger"} onMouseEnter={(e) => handleMouseEnter(e, 4)} onMouseLeave={() => handleMouseLeave(4)}>
                            <Link to="/catalogs/global-services" className='inner_layer guid_show3'>
                                <img src={require('../../assets/sidebaricons/icon2.svg').default} alt=''/>
                                <span className="target target_sidevisible"
                                onMouseEnter={() => handleTooltipEnter(4)}
                                onMouseLeave={() => handleTooltipLeave(4)}
                                style={{
                                    display: visibleId === 4 ? 'block' : 'block',
                                    position: 'fixed',
                                    top: positions[4]?.top ?? 0,
                                    left: visibleId === 4 && positions[4]?.left !== undefined ? positions[4].left : -255,
                                    // left: positions[1]?.left ?? 0,
                                }}>Catalog</span>
                            </Link>
                        </div>
                    </>}
                    {(roles && roles === 'job_seeker' && permissionstest && permissionstest.manage_my_tasks === true) &&
                        <div className={currentPath.startsWith("/task") ? "sidelinks active_side trigger" : "sidelinks trigger"} onMouseEnter={(e) => handleMouseEnter(e, 9)} onMouseLeave={() => handleMouseLeave(9)}>
                            <Link to="/task/my-task" className='inner_layer'>
                                <img src={require('../../assets/sidebaricons/icon6.svg').default} alt=''/>
                                <span className="target target_sidevisible"
                                    onMouseEnter={() => handleTooltipEnter(9)}
                                    onMouseLeave={() => handleTooltipLeave(9)}
                                    style={{
                                        display: visibleId === 9 ? 'block' : 'block',
                                        position: 'fixed',
                                        top: positions[9]?.top ?? 0,
                                        left: visibleId === 9 && positions[9]?.left !== undefined ? positions[9].left : -255,
                                        // left: positions[1]?.left ?? 0,
                                    }}>Task</span>
                            </Link>
                        </div>
                    }
                    {roles && roles !== "job_seeker" && permissionstest && permissionstest.manage_job_posts === true && permissionstest.manage_job_post_viewer === true && <>
                    <div className={currentPath.startsWith("/job-board") ? "sidelinks active_side trigger" : "sidelinks trigger"} onMouseEnter={(e) => handleMouseEnter(e, 10)} onMouseLeave={() => handleMouseLeave(10)}>
                        <Link to="/job-board" className='inner_layer' onClick={() =>{navigate("/job-board")}}>
                            <img src={require('../../assets/sidebaricons/icon12.svg').default} alt=''/>
                            <span className="target target_sidevisible"
                                onMouseEnter={() => handleTooltipEnter(10)}
                                onMouseLeave={() => handleTooltipLeave(10)}
                                style={{
                                    display: visibleId === 10 ? 'block' : 'block',
                                    position: 'fixed',
                                    top: positions[10]?.top ?? 0,
                                    left: visibleId === 10 && positions[10]?.left !== undefined ? positions[10].left : -255,
                                    // left: positions[1]?.left ?? 0,
                                }}>Job Board</span>
                        </Link>
                    </div>
                    </>}
                    {roles && roles !== "job_seeker" && permissionstest?.recruiter_admin === true && <>
                    <div className={currentPath.startsWith("/recruiter") ? "sidelinks active_side trigger" : "sidelinks trigger"} onMouseEnter={(e) => handleMouseEnter(e, 18)} onMouseLeave={() => handleMouseLeave(18)}>
                        <div className='inner_layer'>
                            <img src={require('../../assets/sidebaricons/icon18.svg').default} alt=''/>
                            <span className='sidenewdrshows target' 
                                onMouseEnter={() => handleTooltipEnter(18)}
                                onMouseLeave={() => handleTooltipLeave(18)}
                                style={{
                                    display: visibleId === 18 ? 'block' : 'block',
                                    position: 'fixed',
                                    top: positions[18]?.top ?? 0,
                                    left: visibleId === 18 && positions[18]?.left !== undefined ? positions[18].left : -255,
                                    // left: positions[1]?.left ?? 0,
                                }}>C2C
                                <div className='list_showers'>
                                    <div className='d-flex flex-column'>
                                        <small className={currentPath === "/recruiter/it-recruiter" ? "activesmallersb" : ""}><Link className="link_headsets" to="/recruiter/it-recruiter" >IT Recruiter</Link></small>
                                        <small className={currentPath === "/recruiter/vendor-company" ? "activesmallersb" : ""} ><Link className="link_headsets" to="/recruiter/vendor-company" >Vendor Company</Link></small>
                                    </div>
                                </div>
                            </span>
                        </div>
                    </div>
                    </>}
                    {(roles && roles === 'job_seeker' && permissionstest && permissionstest.manage_job_posts === true && permissionstest.manage_job_post_viewer === true) &&
                    <div className={currentPath.startsWith("/job-board") ? "sidelinks active_side trigger" : "sidelinks trigger"} onMouseEnter={(e) => handleMouseEnter(e, 11)} onMouseLeave={() => handleMouseLeave(11)}>
                        <Link to="/job-board/job-list" className='inner_layer'>
                            <img src={require('../../assets/sidebaricons/icon12.svg').default} alt=''/>
                            <span className="target target_sidevisible"
                            onMouseEnter={() => handleTooltipEnter(11)}
                            onMouseLeave={() => handleTooltipLeave(11)}
                            style={{
                                display: visibleId === 11 ? 'block' : 'block',
                                position: 'fixed',
                                top: positions[11]?.top ?? 0,
                                left: visibleId === 11 && positions[11]?.left !== undefined ? positions[11].left : -255,
                                // left: positions[1]?.left ?? 0,
                            }}>Job Board</span>
                        </Link>
                    </div>
                    }

                    {(roles === 'admin') &&
                        <div className={currentPath.startsWith("/settings") ? "sidelinks active_side trigger" : "sidelinks trigger"} onMouseEnter={(e) => handleMouseEnter(e, 12)} onMouseLeave={() => handleMouseLeave(12)}>
                            <Link to="/settings/general" className='inner_layer'>
                                <img src={require('../../assets/sidebaricons/icon11.svg').default} alt=''/>
                                <span className="target target_sidevisible"
                                onMouseEnter={() => handleTooltipEnter(12)}
                                onMouseLeave={() => handleTooltipLeave(12)}
                                style={{
                                    display: visibleId === 12 ? 'block' : 'block',
                                    position: 'fixed',
                                    top: positions[12]?.top ?? 0,
                                    left: visibleId === 12 && positions[12]?.left !== undefined ? positions[12].left : -255,
                                    // left: positions[1]?.left ?? 0,
                                }}>Company Settings</span>
                            </Link>
                        </div>
                    }

                    {permissionstest && permissionstest.manage_employee_reviews === true  && <>
                        <div className={currentPath.startsWith("/employee-reviews") ? "sidelinks active_side trigger" : "sidelinks trigger"} onMouseEnter={(e) => handleMouseEnter(e, 13)} onMouseLeave={() => handleMouseLeave(13)}>
                            <Link to="/employee-reviews" className='inner_layer' onClick={() =>{navigate("/employee-reviews")}}>
                                <img src={require('../../assets/sidebaricons/icon14.svg').default} alt=''/>
                                <span className="target target_sidevisible"
                                    onMouseEnter={() => handleTooltipEnter(13)}
                                    onMouseLeave={() => handleTooltipLeave(13)}
                                    style={{
                                        display: visibleId === 13 ? 'block' : 'block',
                                        position: 'fixed',
                                        top: positions[13]?.top ?? 0,
                                        left: visibleId === 13 && positions[13]?.left !== undefined ? positions[13].left : -255,
                                        // left: positions[1]?.left ?? 0,
                                    }}>Employee Reviews</span>
                            </Link>
                        </div>
                    </>}

                    {permissionstest && permissionstest.manage_org_chart === true  && <>
                    <div className={currentPath.startsWith("/org-chart") ? "sidelinks active_side trigger" : "sidelinks trigger"} onMouseEnter={(e) => handleMouseEnter(e, 14)} onMouseLeave={() => handleMouseLeave(14)}>
                        <Link to="/org-chart" className='inner_layer' onClick={() =>{navigate("/org-chart")}}>
                            <img src={require('../../assets/sidebaricons/icon15.svg').default} alt=''/>
                            <span className="target target_sidevisible"
                                onMouseEnter={() => handleTooltipEnter(14)}
                                onMouseLeave={() => handleTooltipLeave(14)}
                                style={{
                                    display: visibleId === 14 ? 'block' : 'block',
                                    position: 'fixed',
                                    top: positions[14]?.top ?? 0,
                                    left: visibleId === 14 && positions[14]?.left !== undefined ? positions[14].left : -255,
                                    // left: positions[1]?.left ?? 0,
                                }}>Org Chart</span>
                        </Link>
                    </div></>}
                    </div>
                </>
                }
            </div>
            <Modal
                show={show} 
                onHide={handleClose}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                >
                <Modal.Header closeButton style={{border:"none"}}>
                    <h4 className='mb-0' style={{fontWeight:"600"}}>Reset Password</h4>
                </Modal.Header>
                <Modal.Body>
                <Grid size={{xs:12}} container className="mb-3" justifyContent="center">
                    <form className='row justify-content-center w-100' onSubmit={handleSubmit}>
                        <Grid size={{ xs: 12 }} container justifyContent="space-between" className="add_memberfields">
                            <Grid size={{ xs: 12 }} container justifyContent="space-between">
                                <Grid size={{ xs: 12 }} container flexDirection="column" className="mb-4">
                                    <span>Old Password</span>
                                    <div className='d-flex input_witheye'>
                                        <input
                                            name="current_password"
                                            type={passwordVisible1 ? 'text' : 'password'}
                                            value={formData.current_password}
                                            onChange={handleInputChange}
                                            placeholder="Abcd123#"
                                            style={{ width: '100%', paddingRight: '40px' }}
                                        />
                                        <button type="button" onClick={togglePasswordVisibility1}>
                                            {passwordVisible1 ? <FontAwesomeIcon icon={faEyeSlash} /> : <FontAwesomeIcon icon={faEye} />}
                                        </button>
                                    </div>
                                    {errors.current_password && <p style={{ color: "red" }}>{errors.current_password}</p>}
                                </Grid>
                                <Grid size={{ xs: 12 }} container flexDirection="column" className="mb-4">
                                    <span>New Password</span>
                                    <div className='d-flex input_witheye'>
                                        <input
                                            name="password"
                                            type={passwordVisible ? 'text' : 'password'}
                                            value={formData.password}
                                            onChange={handleInputChange}
                                            placeholder="Abcd123#"
                                            style={{ width: '100%', paddingRight: '40px' }}
                                        />
                                        <button type="button" onClick={togglePasswordVisibility}>
                                            {passwordVisible ? <FontAwesomeIcon icon={faEyeSlash} /> : <FontAwesomeIcon icon={faEye} />}
                                        </button>
                                    </div>
                                    {errors.password && <p style={{ color: "red" }}>{errors.password}</p>}
                                </Grid>
                                {/* Confirm Password */}
                                <Grid size={{ xs: 12 }} container flexDirection="column" className="mb-4">
                                    <span>Confirm Password</span>
                                    <div className='d-flex input_witheye'>
                                        <input
                                            name="password_confirmation"
                                            value={formData.password_confirmation}
                                            onChange={handleInputChange}
                                            type={passwordVisible2 ? 'text' : 'password'}
                                            placeholder="Abcd123#"
                                            style={{ width: '100%', paddingRight: '40px' }}
                                        />
                                        <button type="button" onClick={togglePasswordVisibility2}>
                                            {passwordVisible2 ? <FontAwesomeIcon icon={faEyeSlash} /> : <FontAwesomeIcon icon={faEye} />}
                                        </button>
                                    </div>
                                    {errors.password_confirmation && <p style={{ color: "red" }}>{errors.password_confirmation}</p>}
                                </Grid>
                            </Grid>
                            {errorsmessage && <p style={{ color: "red", textAlign: "center" }}>{errorsmessage}</p>}
                            {/* Submit Button */}
                            <Grid size={{sm:12,xs:12}} container justifyContent="flex-end" className=" mt-5">
                                {/* <button type="button" className='registersendbtn1 my-0' onClick={()=> setEditMode(false)}>Cancel</button> */}
                                <button type="submit" className='registersendbtn2 w-100 my-0'>{btnloading ? <img src={require('../../assets/whiteloader.gif')} alt=''/> : 'Update'}</button>
                            </Grid>
                        </Grid>
                    </form>
                </Grid>
                </Modal.Body>
            </Modal>
            <Modal
                show={show2} 
                onHide={handleClose2}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                >
                <Modal.Header closeButton style={{border:"none"}}>
                    
                </Modal.Header>
                <Modal.Body>
                    <div className='d-flex w-100 text-center flex-column align-items-center modal_register'>
                        <FontAwesomeIcon className='main_tickiconpopup' icon={faCircleCheck} />
                        <h3>Successfully</h3>
                        <small>Your password has been updated successfully. You can now log in with your new password.</small>
                        <button onClick={handleClose2}>OK</button>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    </div>
  )
}

export default Allheader
